import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {BASE_URL } from "./Api/Api";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { logoutStatic } from "../../StateManagement/authSlice";

export const DiscountBox = ({ insuranceData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    name,
    family,
    coin,
    regdate: userRegDate,
    InsPay,
    grade,
  } = useSelector((state) => state.auth);
  const [globalData, setGlobalData] = useState({});

  let userLevel = "";
  switch (grade) {
    case 0: {
      userLevel = "عادی";
      break;
    }
    case 1: {
      userLevel = "نقره ای";
      break;
    }
    case 2: {
      userLevel = "پلاتینیوم";
      break;
    }
    default: {
      userLevel = "عادی";
    }
  }

  const priceCoin = coin * 100;

  // calculate end date of user discount
  const originalDate = new Date(userRegDate);

  const endDateOfInitialDiscount = new Date(originalDate);
  endDateOfInitialDiscount.setMonth(originalDate.getMonth() + 9);

  // Wed Aug 28 2024 14:45:57 GMT+0330 (Iran Standard Time)

  const timeDifference =
    endDateOfInitialDiscount.getTime() - new Date().getTime();
  const dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  // Calculate the equivalent in months (assuming 30 days in a month)
  const monthDifference = Math.ceil(dayDifference / 30);

  // Multiply by 5
  const discountPercent = monthDifference * 5;
  // console.log(discountPercent, 'discount percent')

  let discountLabel = globalData?.InsDiscount;
  if (endDateOfInitialDiscount < new Date()) {
    discountLabel = discountPercent;
  }

  const InsPriceBeforeDiscount =
    globalData?.InsPrice -
    globalData.InsPrice * (globalData?.InsDiscount / 100);
  let roundedNumber = Math.floor(InsPriceBeforeDiscount / 100000) * 100000;

  const InsPriceAfterDiscount =
    globalData?.InsPrice -
    globalData?.InsPrice * (globalData?.InsDiscount / 100) -
    priceCoin;
  // console.log(InsPriceAfterDiscount, 'ins pri after dis')

  const InsPriceBefor9Month =
    globalData?.InsPrice -
    globalData?.InsPrice * (globalData?.InsDiscount / 100);
  // console.log((InsPriceBefor9Month.toString().substring(0, InsPriceBefor9Month.length - 5) + '00000'), 'b 9 m ins price')

  // Progress Bar
  const coinsPercent = ((priceCoin * 100) / InsPriceBeforeDiscount).toFixed(2);
  // console.log( coinsPercent,priceCoin,InsPriceBeforeDiscount)
  const pucketPercent = ((InsPay * 100) / InsPriceBeforeDiscount).toFixed(2);
  // console.log(pucketPercent, coinsPercent, 'puck perc')

  const fetchData = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    const responsePromise = axios.post(BASE_URL, bodyFormData, {
      headers: {
        cmd: "global",
        "Content-type": "multipart/form-date",
      },
    });

    responsePromise
      .then((responseGlobal) => {
        if (responseGlobal.status === 200) {
          if (responseGlobal?.data?.UserId === "0") {
            dispatch(logoutStatic());
            navigate("/");
          }
          const data = responseGlobal?.data?.GlobalData;
          setGlobalData(data);
        } else {
          console.error(
            `API request failed with status: ${responseGlobal.status}`
          );
        }
      })
      .catch((error) => {
        console.error("Error while fetching menu data:", error);
      });
  };

  const [timeLeft, setTimeLeft] = useState(0); // Initialize with the remaining time in seconds

  useEffect(() => {
    const endDate = endDateOfInitialDiscount;
    if (endDate > new Date()) {
      // console.log(endDate, 'end date')
      const initialTimeLeft = Math.floor(
        (endDate.getTime() - new Date().getTime()) / 1000
      );
      setTimeLeft(initialTimeLeft);

      const intervalId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(intervalId); // Cleanup on component unmount
    } else {
      const initialTimeLeft = Math.floor(
        (endDate.getTime() - new Date().getTime()) / 1000
      );
      setTimeLeft(initialTimeLeft);

      const intervalId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime + 1);
      }, 1000);

      return () => clearInterval(intervalId); // Cleanup on component unmount
    }
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) {
      // Perform actions when countdown reaches zero
      const countdownContent = document.querySelector(".countdown-content");
      const countdownContentFinal = document.querySelector(
        ".countdown-content-final"
      );
      if (countdownContent && countdownContentFinal) {
        countdownContent.classList.add("d-none");
        countdownContentFinal.classList.add("d-flex");
      }
    }
  }, [timeLeft]);

  useEffect(() => {
    fetchData();
  }, []);

  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  const months = Math.floor(timeLeft / (86400 * 30));
  const days = Math.floor((timeLeft / 86400) % 30);
  const hours = Math.floor((timeLeft % 86400) / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = Math.floor(timeLeft % 60);
  return (
    <div id="countdowngrade" className="card m-auto wd-50 wm-100 mb-4 mt-5">
      <div className="card-body  ">
        <div dir="rtl" className="row ">
          <div className="col-lg-3 col-6 text-center m-auto text-primary">
            <label id="lblname">
              {name} {family}
            </label>
            <br />
            <label id="lblgrade">سطح:{userLevel}</label>
          </div>
          <div className="col-lg-3 col-6 m-auto text-center text-warning">
            <h5 id="discountpercent" className="m-0">
              %{globalData?.InsDiscount}
            </h5>
            <small className="d-block">مبلغ پرداخت بیمه نامه</small>
            <small> با تخفیف :</small>
            <small id="Insafterdiscount" className="text-primary">
              {roundedNumber?.toLocaleString()}{" "}
            </small>
          </div>
          <div className="col-lg-6 col-12 ">
            <hr className="hidden-md mt-2" />
            <div className="row">
              <div className="col-6 text-primary">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{"قیمت بیمه بدون تخفیف"}</Tooltip>}
                >
                  <span>
                    <small>{globalData?.InsPrice?.toLocaleString()}</small>
                  </span>
                </OverlayTrigger>
              </div>
              <div className="col-6 text-primary text-end ">
                <span>0</span>
              </div>
              <div className="col-12">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>{"میزان تخفیف جهت صدور بیمه نامه"}</Tooltip>
                  }
                >
                  <div className="progress" dir="ltr">
                    <div
                      className="progress-bar bg-success"
                      style={{ width: `${discountLabel}%` }}
                    >
                      <label>%{discountLabel}</label>
                    </div>
                    <div
                      className="progress-bar bg-info"
                      style={{ width: `${coinsPercent}%` }}
                    >
                      <label>%{coinsPercent}</label>
                    </div>
                    <div
                      className="progress-bar bg-danger"
                      style={{ width: `${pucketPercent}%` }}
                    >
                      <label>%{pucketPercent}</label>
                    </div>
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      {"زمان باقیمانده جهت صدور بیمه نامه با تخفیف"}
                    </Tooltip>
                  }
                >
                  <div className="text-center mt-3">
                    <span id="hdfenddate" />
                    <div
                      className="text-primary"
                    >
                      <b >{formatTime(hours)}</b>:
                      <b >{formatTime(minutes)}</b>:
                      <b >{formatTime(seconds)}</b>
                      &nbsp;&nbsp;&nbsp;
                      <b >{formatTime(days)}</b>
                      <span>روز</span>
                      &nbsp;
                      <b >{formatTime(months)}</b>
                      <span>ماه</span>
                    </div>
                  </div>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
